import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ComponentBase } from "src/app/core/helpers/component-base.directive";
import { TranslateConfigService } from "src/app/core/services/translate-config.service";
import { SidebarService } from "src/app/layout/sidebar/sidebar-service/sidebar.service";
import { Subscription } from "rxjs";
import { NetworkErrorConnectionService } from "../../../../core/services/network-error-connection.service";
import { Router } from "@angular/router";
import { Config } from "../../../../core/config/api.config";
import { HttpHandlerService } from "../../../../core/services/http-handler.service";

@Component({
  selector: "app-internet-connection-failed",
  templateUrl: "./internet-connection-failed.component.html",
  styleUrls: ["./internet-connection-failed.component.scss"],
})
export class InternetConnectionFailed extends ComponentBase implements OnInit, OnDestroy {
  latestLocation = localStorage.getItem("latestLocation");
  lang = this.translate.currentLang;
  subscription = new Subscription();

  constructor(
    private sidebarService: SidebarService,
    private httpSer: HttpHandlerService,
    private NetworkErrorConnectionService: NetworkErrorConnectionService,
    translateService: TranslateConfigService,
    translate: TranslateService,
    private route: Router,
  ) {
    super(translateService, translate);
  }

  ngOnInit(): void {
    // window.addEventListener("online", (e)=> {
    // setTimeout(()=>{
    //   window.history.back()
    // }, 3000)
    //
    // });
    this.getEmployees();
  }

  getEmployees() {
    this.httpSer
      .get(Config.UserManagement.GetAll, { pageIndex: 1, pageSize: 10 })
      .pipe()
      .subscribe((res) => {
        if (res){
          this.goBack()
        }
      });
  }

  goBack() {
    // if (this.NetworkErrorConnectionService.getConnectionStatus() == 'ONLINE'){
    //   window.history.back()
    // }else {
    //   return
    // }
    // this.route.navigate(["/"]);
    window.history.back()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
